// extracted by mini-css-extract-plugin
export var boxItems = "_7m-1";
export var boxItemsLg = "_7m-2";
export var button = "_7m-7";
export var buttonHoverless = "_7m-9";
export var buttonLg = "_7m-8";
export var filterGroupBox = "_7m-0";
export var icon = "_7m-3";
export var iconSecondary = "_7m-6";
export var iconWrapper = "_7m-4";
export var iconWrapperLg = "_7m-5";
export var truncatedLabel = "_7m-a";